module.exports = __webpack_public_path__ + "static/media/myneflix3.3c6ea765.png";